export enum ActionType {
    SELECT_PAGE = '[PAGED QM MESSAGES CONTEXT] SELECT PAGE',
    SET_TOTAL_NUMBER_OF_MESSAGES = '[PAGED QM MESSAGES CONTEXT] SET TOTAL NUMBER OF MESSAGES',
    TOGGLE_DETAIL_EXPANDED = '[PAGED QM MESSAGES CONTEXT] TOGGLE DETAIL EXPANDED',
    SORT_DATA = '[PAGED QM MESSAGES CONTEXT] SORT DATA',
}
